import {Basic, Ventrata} from 'types'
import {CostFromPerBooking} from './CostFromPerBooking'
import {CostFromPerUnit} from './CostFromPerUnit'

type Props = {
  product: Ventrata.Product
  currency: Basic.Currency
}

export const CostFrom = ({product, currency}: Props) => {
  switch (product.pricingPer) {
    case 'BOOKING':
      return <CostFromPerBooking product={product} currency={currency} />
    case 'UNIT':
      return <CostFromPerUnit product={product} currency={currency} />
    default:
      return null
  }
}
